import ApiService from 'services/ApiService';

const badRequestCode = 400;

function apiRequest(apiCall) {
    return new Promise((resolve, reject) => {
        apiCall.then(
            (result) => { resolve(result.data); },
            (error) => { reject(error); });
    });
}

export const EarnedRecognitionService = {
    getEarnedRecognition() {
        return apiRequest(ApiService.get('/reporting/EarnedRecognition'));
    },
    saveEarnedRecognition(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put('/reporting/EarnedRecognition', settings).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response.data);
                    } else {
                        reject('Unable to update Earned Recognition settings. Please try again later.');
                    }
                });
        });
    },
    getChangelog(pageSize, pageNumber, startDate, endDate) {
        return apiRequest(ApiService.get(`/reporting/EarnedRecognition/changelog?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`));
    },
    getDriverHoursKpis(startDate) {
        const query = startDate ? `?startDate=${encodeURIComponent(startDate)}` : "";
        return apiRequest(ApiService.get(`/reporting/EarnedRecognition/DriverHoursKpis${query}`));
    },
    getMaintenanceKpis(startDate) {
        const query = startDate ? `?startDate=${encodeURIComponent(startDate)}` : "";
        return apiRequest(ApiService.get(`/reporting/EarnedRecognition/MaintenanceKpis${query}`));
    },
    getKpiThresholds() {
        // Trigger-threshold bands (per-KPI severity description, colour and pass-rate range) used to
        // name the period-status severity on the Maintenance and Driver KPI Drilldowns. Resolves to
        // { driverHoursThresholds, maintenanceThresholds }.
        return apiRequest(ApiService.get('/reporting/Options/EarnedRecognitionKpiThresholds'));
    },
    searchDriverHoursEmployees(request) {
        // Period-scoped employee search backing the Driver KPI Drilldown (PBI 160899). Routed to
        // EmployeeMS (not Reporting) as the driver-hours employee data lives there.
        return apiRequest(ApiService.post('/employee/EarnedRecognition/DriverHoursEmployees/Search', request));
    },
    searchMaintenanceAssets(request) {
        // Period-scoped asset search backing the Maintenance KPI Drilldown (PBI 162027). Routed to
        // CheckMS (not Reporting) as the maintenance KPI asset data lives there.
        return apiRequest(ApiService.post('/check/EarnedRecognition/MaintenanceAssets/Search', request));
    },
    validateMaintenanceKpi(vehicleFrequencyWeeks, trailerFrequencyWeeks) {
        // Build the query string by appending only the parameters that were supplied.
        // Omitting a parameter signals to the backend that it should fall back to the DB default for that field.
        const params = [];

        if (vehicleFrequencyWeeks != null) {
            params.push(`vehicleFrequencyWeeks=${encodeURIComponent(vehicleFrequencyWeeks)}`);
        }

        if (trailerFrequencyWeeks != null) {
            params.push(`trailerFrequencyWeeks=${encodeURIComponent(trailerFrequencyWeeks)}`);
        }

        const queryString = params.length > 0 ? `?${params.join('&')}` : '';
        return new Promise((resolve, reject) => {
            ApiService.get(`/check/EarnedRecognition/MaintenanceKpiValidation${queryString}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    if (error.response.status === badRequestCode) {
                        reject(error.response.data);
                    } else {
                        reject('Unable to validate maintenance KPI configuration. Please try again later.');
                    }
                });
        });
    }
};
